import { fetch as apiFetch, postData } from "../../Component/function/FunctionApi";

const BASE_URL = "https://weviira-001-site1.jtempurl.com/api/";

/**
 * Get representatives
 */
export const getRepresentatives = async () => {
  try {
    const response = await apiFetch(
      "Represntative/get-Represntatives"
    );

    return response;
  } catch (error) {
    console.error("getRepresentatives error:", error);
    throw error;
  }
};

/**
 * Get representative daily data
 */
export const getRepresentativeDailyData = async (
  representativeId,
  date
) => {
  try {
    const params = new URLSearchParams({
      represntativeId: String(representativeId),
      dateDaily: `${date}T00:00:00`,
    });

    const response = await apiFetch(
      `Represntative/get-dailyDateOfRepresntative?${params.toString()}`
    );

    return response;
  } catch (error) {
    console.error("getRepresentativeDailyData error:", error);
    throw error;
  }
};

/**
 * Update shipping for all invoices
 */
export const updateDailyShipping = async ({
  representativeId,
  dailyDate,
  invoicesShipping,
}) => {
  try {
    const body = {
      representativeId: Number(representativeId),
      dailyDate,
      invoicesShipping: invoicesShipping.map((item) => ({
        invoiceId: Number(item.invoiceId),
        shipping: Number(item.shipping) || 0,
      })),
    };

    const response = await postData(
      "Represntative/update-daily-shipping",
      body,
      () => {}
    );

    return response;
  } catch (error) {
    console.error("updateDailyShipping error:", error);
    throw error;
  }
};

/**
 * Save daily settlement
 */
export const saveDailySettlement = async ({
  representativeId,
  dailyDate,
  cashAmount,
  instaPayAmount,
  vodafoneCashAmount,
  manualDueAmount,
  notes,
}) => {
  try {
    const body = {
      representativeId: Number(representativeId),
      dailyDate,
      manualDueAmount: Number(manualDueAmount) || 0,
      cashAmount: Number(cashAmount) || 0,
      instaPayAmount: Number(instaPayAmount) || 0,
      vodafoneCashAmount: Number(vodafoneCashAmount) || 0,
      notes: notes || "",
    };

    const response = await postData(
      "Represntative/save-daily-settlement",
      body,
      () => {}
    );

    return response;
  } catch (error) {
    console.error("saveDailySettlement error:", error);
    throw error;
  }
};


/* =========================================================
   TOGGLE RETURNS RECEIVED
========================================================= */

export const toggleReturnsReceived = async ({
  representativeId,
  dailyDate,
  isReturnsReceived,
}) => {
  try {
    const response = await postData(
      "Represntative/toggle-returns-received",
      {
        representativeId,
        dailyDate,
        isReturnsReceived,
      }
    );

    return response;
  } catch (error) {
    console.error(
      "toggle returns received error:",
      error
    );

    throw error;
  }
};


export const saveFinalSettlementPayments = async ({
  representativeId,
  dailyDate,
  finalForRepresentativeCashAmount,
  finalForRepresentativeInstaPayAmount,
  finalForRepresentativeVodafoneCashAmount,
  finalOnRepresentativeCashAmount,
  finalOnRepresentativeInstaPayAmount,
  finalOnRepresentativeVodafoneCashAmount,
}) => {
  try {
    const body = {
      representativeId: Number(representativeId),
      dailyDate,

      finalForRepresentativeCashAmount:
        Number(finalForRepresentativeCashAmount) || 0,

      finalForRepresentativeInstaPayAmount:
        Number(finalForRepresentativeInstaPayAmount) || 0,

      finalForRepresentativeVodafoneCashAmount:
        Number(finalForRepresentativeVodafoneCashAmount) || 0,

      finalOnRepresentativeCashAmount:
        Number(finalOnRepresentativeCashAmount) || 0,

      finalOnRepresentativeInstaPayAmount:
        Number(finalOnRepresentativeInstaPayAmount) || 0,

      finalOnRepresentativeVodafoneCashAmount:
        Number(finalOnRepresentativeVodafoneCashAmount) || 0,
    };

    const response = await postData(
      "Represntative/save-final-settlement-payments",
      body,
      () => {}
    );

    return response;
  } catch (error) {
    console.error(
      "saveFinalSettlementPayments error:",
      error
    );
    throw error;
  }
};

/**
 * Process final balance transaction
 */
export const processBalanceTransaction = async ({
  representativeId,
  dailyDate,
  amount,
  paymentMethod,
  transactionType,
  notes,
}) => {
  try {
    const body = {
      representativeId: Number(representativeId),
      dailyDate,
      amount: Number(amount) || 0,
      paymentMethod,
      transactionType,
      notes: notes || "",
    };

    const response = await postData(
      "Represntative/process-balance-transaction",
      body,
      () => {}
    );

    return response;
  } catch (error) {
    console.error("processBalanceTransaction error:", error);
    throw error;
  }
};